/* if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    console.trace('[NAV] beforeunload');
  });

  const origPushState = history.pushState;
  history.pushState = function (...args) {
    console.trace('[NAV] pushState', args);
    return origPushState.apply(this, args as any);
  };

  const origReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    console.trace('[NAV] replaceState', args);
    return origReplaceState.apply(this, args as any);
  };

  window.addEventListener('keydown', (e) => {
    console.log('[KEYDOWN]', {
      key: e.key,
      code: e.code,
      metaKey: e.metaKey,
      ctrlKey: e.ctrlKey,
      altKey: e.altKey,
      shiftKey: e.shiftKey,
      target: e.target,
    });
  });

  const navDebugWindow = window as typeof window & {
    __navDebugInstalled?: boolean;
  };

  if (!navDebugWindow.__navDebugInstalled) {
    navDebugWindow.__navDebugInstalled = true;

    const navLog = (...args: any[]) => {
      console.info('[NAV]', ...args);
    };

    window.addEventListener('beforeunload', () => {
      console.info('[NAV] beforeunload');
    });

    window.addEventListener('pagehide', (e) => {
      navLog('pagehide', {
        persisted: (e as PageTransitionEvent).persisted,
      });
    });

    window.addEventListener('pageshow', (e) => {
      navLog('pageshow', {
        persisted: (e as PageTransitionEvent).persisted,
      });
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.info('[NAV] unhandledrejection', event.reason);
    });

    window.addEventListener('error', (event) => {
      console.info('[NAV] error', {
        message: event.message,
        filename: event.filename,
        error: event.error,
      });
    });

    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      console.info('[NAV] pushState', args);
      return originalPushState.apply(this, args as any);
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (...args) {
      console.info('[NAV] replaceState', args);
      return originalReplaceState.apply(this, args as any);
    };
  }
}

(() => {
  const originalAddEventListener = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function (type, listener, options) {
    const wrapped = function (event) {
      const filter = [
        'animationiteration',
        'animationstart',
        'animationend',
        'transitionstart',
        'transitionrun',
        'transitionend',
        'transitioncancel',
        'timeupdate',
        'pointermove',
        'pointerover',
        'pointerout',
        'pointerenter',
        'pointerleave',
        'mousemove',
        'mouseover',
        'mouseout',
        'mouseenter',
        'mouseleave',
        'canplay',
        'canplaythrough',
        'playing',
        'seeked',
        'seeking',
      ];
      try {
        if (!filter.includes(type)) {
          console.info('[EVENT]', type, {
            target: event.target,
            currentTarget: event.currentTarget,
          });
        }
      } catch (e) {}

      return listener.apply(this, arguments);
    };

    return originalAddEventListener.call(this, type, wrapped, options);
  };
})(); */

import type { GatsbyBrowser } from "gatsby";
import { RootElement } from "./gatsby-root";
import { LanguageChangeWrapper } from "./src/i18n/language-change-wrapper";
import { ProjectSpecificPageWrapper } from "./src/project-specific/page-wrapper/project-sepcific-page-wrapper";
import { scrollToAnchor } from "./src/hooks/scroll-to-anchor";
import { PageMeta } from "./src/site/core/meta";

export const shouldUpdateScroll = () => false;

export const onPreRouteUpdate = ({ location, prevLocation }: any) => {
	console.log("[GATSBY] onPreRouteUpdate", {
		from: prevLocation?.href,
		to: location?.href,
		currentHash: (window as any).___webpackCompilationHash,
	});
};

if (typeof window !== "undefined") {
	window.addEventListener("hashchange", () =>
		scrollToAnchor(window.location.hash),
	);
}

export const onRouteUpdate = ({ location, prevLocation }: any) => {
	// Query-only updates (e.g. agenda filters) must not re-scroll to the hash anchor
	const queryOnlyUpdate =
		prevLocation &&
		prevLocation.pathname === location?.pathname &&
		prevLocation.hash === location?.hash;
	if (!queryOnlyUpdate)
		scrollToAnchor(location?.hash || "", { instant: !prevLocation });
	console.log("[GATSBY] onRouteUpdate", {
		from: prevLocation?.href,
		to: location?.href,
		currentHash: (window as any).___webpackCompilationHash,
	});
};

// Handle chunk loading errors after deployments (stale cache)
/* export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
	// Listen for unhandled errors that indicate stale chunks
	window.addEventListener("error", (event) => {
		// Check if this is a chunk loading error
		if (
			event.message?.includes("Loading chunk") ||
			event.message?.includes("ChunkLoadError") ||
			event.message?.includes("Failed to fetch dynamically imported module") ||
			event.error?.name === "ChunkLoadError"
		) {
			// Prevent infinite reload loop by checking sessionStorage
			const reloadKey = "chunk-reload-attempted";
			if (!sessionStorage.getItem(reloadKey)) {
				sessionStorage.setItem(reloadKey, "true");
				console.warn(
					"Chunk loading failed, likely due to a new deployment. Reloading page...",
				);
				window.location.reload();
			}
		}
	});

	// Clear the reload flag when the page loads successfully
	// This allows future reloads if another deployment happens
	window.addEventListener("load", () => {
		// Use a small delay to ensure chunks have loaded
		setTimeout(() => {
			sessionStorage.removeItem("chunk-reload-attempted");
		}, 5000);
	});
};
 */
export const wrapPageElement = ({ element, props }) => {
	return (
		<LanguageChangeWrapper pageLanguage={props.pageContext.lang}>
			<ProjectSpecificPageWrapper {...props}>
				<PageMeta {...props} />
				<div className={props.pageContext?.pageCssClass}>{element}</div>
			</ProjectSpecificPageWrapper>
		</LanguageChangeWrapper>
	);
};

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({
	element,
}) => {
	return <RootElement>{element}</RootElement>;
};
